import { render, staticRenderFns } from "./AppSidenav.vue?vue&type=template&id=18ec8169&scoped=true"
import script from "./AppSidenav.vue?vue&type=script&lang=js"
export * from "./AppSidenav.vue?vue&type=script&lang=js"
import style0 from "./AppSidenav.vue?vue&type=style&index=0&id=18ec8169&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec8169",
  null
  
)

export default component.exports